var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 409.6 409.6",
    style: {
      enableBackground: "new 0 0 409.6 409.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,217.16c0-7.99,0-15.97,0-23.96c0.86-6.84,1.49-13.72,2.63-20.51c7.18-42.56,25.59-79.62,56.05-110.16 C104.52,16.6,160.16-3.93,224.87,1.9c39.96,3.6,75.97,18.35,106.86,43.93c56.24,46.57,82.01,106.64,76.05,179.56 c-2.75,33.74-14.27,64.83-33.4,92.78c-32.82,47.95-77.76,77.72-135.11,88.27c-7.55,1.39-15.23,2.12-22.85,3.15 c-7.99,0-15.97,0-23.96,0c-2.75-0.32-5.5-0.67-8.25-0.97c-33.67-3.6-64.83-14.42-92.78-33.55C43.48,342.27,13.7,297.34,3.15,240 C1.76,232.45,1.03,224.78,0,217.16z M180.49,240.83c0,19.83-0.14,39.66,0.04,59.49c0.16,17.51,16.09,28.78,32.22,23.05 c9.72-3.45,15.63-12.45,15.64-24.07c0.03-29.01,0.01-58.02,0.01-87.03c0-10.11,0.09-20.23-0.03-30.34 c-0.12-10.92-6.32-19.82-15.84-23.11c-16.19-5.59-31.88,5.74-32.01,23.33C180.38,201.7,180.49,221.27,180.49,240.83z  M228.38,109.33c-0.03-13.03-10.94-23.91-23.96-23.89c-13.03,0.03-23.92,10.94-23.89,23.96c0.03,13.03,10.94,23.91,23.96,23.89 C217.52,133.26,228.4,122.35,228.38,109.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.49,240.83c0-19.56-0.12-39.13,0.03-58.69c0.14-17.59,15.83-28.92,32.01-23.33c9.52,3.29,15.72,12.19,15.84,23.11 c0.11,10.11,0.03,20.23,0.03,30.34c0,29.01,0.02,58.02-0.01,87.03c-0.01,11.62-5.92,20.62-15.64,24.07 c-16.13,5.73-32.06-5.54-32.22-23.05C180.35,280.49,180.49,260.66,180.49,240.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.38,109.33c0.03,13.02-10.86,23.93-23.89,23.96c-13.02,0.03-23.94-10.86-23.96-23.89 c-0.03-13.02,10.86-23.93,23.89-23.96C217.44,85.41,228.35,96.29,228.38,109.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8cf2ee86.svg";
export { ForwardRef as ReactComponent };